import React from "react";
// import TableComandas from "../components/TableComandas";
import AppCtaCteChoferReactTable from "../table/AppCtaCteChoferReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const CtaCteChofer = () => {
  return (
    <>
      <AppCtaCteChoferReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default CtaCteChofer;
